export default __webpack_public_path__ + "static/media/conferenciassan.3b55a18d.png";